/*=========================================================================================
  File Name: moduleTreatmentsMutations.js
  Description: Treatments Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {

    SET_TREATMENTS(state, treatments) {
        state.treatments = [];
        treatments.forEach(el => {
            let treatment = el;
            treatment["side_effects"] = []
            state.treatments.push(treatment)
        })
    },


    SET_SIDE_EFFECTS(state, response) {
        let treatment_index = state.treatments.findIndex(el => el.id === response[0].treatmentId);
        state.treatments[treatment_index]["side_effects"] = response
    },

    SET_LABORATORY_MONITORINGS(state, response) {
        let laboratory_index = state.treatments.findIndex(el => el.id === response[0].treatmentId);
        state.treatments[laboratory_index]["laboratory_monitorings"] = response
    },

}
